import React from 'react';
import css from './GMInfoGridRow.module.scss';
import { GoMotoComponent } from '../../../API/GoMoto.types';
import { GMInfoGridRowProps } from './GMInfoGridRow.types';

export const GMInfoGridRow: GoMotoComponent<GMInfoGridRowProps> = React.memo((props) => (
    <div className={css.infoGridRow}>{props.children}</div>
));
